import { GraphQLClient } from 'graphql-hooks';
import { SubscriptionClient } from 'subscriptions-transport-ws';

const token = window.location.href.includes('access_token=')
  ? window.location.href.split('access_token=')[1].split('&')[0]
  : localStorage.getItem('session')
  ? JSON.parse(localStorage.getItem('session')).sessionInfo?.token
  : null;

const connectionParams = {
  Authorization: `Bearer ${token}`,
};

const subscriptionClient = new SubscriptionClient(
  process.env.REACT_APP_SOCKET_URL,
  {
    reconnect: true,
    connectionParams,
  }
);

/**
 * Instancia única del cliente GraphQL (misma que envuelve ClientContext en index.js).
 * Permite ejecutar mutaciones fuera del ciclo de vida de un componente montado.
 */
export const graphQLClient = new GraphQLClient({
  url: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
  subscriptionClient,
  fetch: async (url, init) => {
    const freshToken = localStorage.getItem('session')
      ? JSON.parse(localStorage.getItem('session')).sessionInfo?.token
      : window.location.pathname.includes('access_token=')
        ? window.location.pathname.split('access_token=')[1].split('&')[0]
        : null;

    init.headers.Authorization = `Bearer ${freshToken}`;
    const response = await fetch(url, init);
    return response;
  },
  connectionParams: {
    setTimeout: 120000,
  },
});
